export default "__VITE_ASSET__B5t6e75___"